import { licenseParams, normalizeCollectionResponse, normalizeRecordResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const licenseQuery = async ({ req, params }) => {
	const formattedParams = { context: ['cache', 'ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/licenses/${params.licenseId}`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const licensesQuery = async ({ req, params }) => {
	const formattedParams = { ...licenseParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/licenses`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
